import {connect} from "react-redux";
import {Card, Row, Col} from "react-bootstrap";
import {getMinutes, getMinutesChart} from "../../../../../../utils/constantValues";
import {ASTRO_DIM_10} from "../../../../../../utils/constantFeatures";
import {getErrorIssues} from "../../../../../../utils/validationSummary";
import {fetchDriverOpmodesSelected} from "../../../../../../actions";
import {fetchDriverProperties, fetchAstroSavings} from "../../../../../../actions";
import {Trans} from 'react-i18next';

import * as d3 from "d3";
import LocationComponent from "./components/LocationComponent";
import moment from "moment";
import BaseFeature from "./BaseFeature";
import PropertyDropdown from "./components/PropertyDropdown";
import PropertyRadio from "./components/PropertyRadio";
import DraggableAreaChart from "./charts/DraggableAreaChart";
import PropertyTableTimePicker10 from "./components/PropertyTableTimePicker10";

class AstroDim10 extends BaseFeature {
    constructor(props) {
        super(props);

        this.state = {
            savings: "Calculating...",
            countryKey: "Custom",
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCountry = this.handleChangeCountry.bind(this);
        this.handleCountryDropdownChange = this.handleCountryDropdownChange.bind(this);
        this.handleChangeReferenceSchedule = this.handleChangeReferenceSchedule.bind(this);
    }

    handleChange(propertyName, value) {
        this.setState({savings: "Calculating..."});
        const v = value;

        if (propertyName) {
            this.props.handleChange(propertyName, v);
            if (this.getCorrectPropertyName(propertyName) === ASTRO_DIM_10.submode) {
                if (value === "0") {
                    this.handleChangeCountry("Custom");
                }
                this.setDefault(v, 0);
            }
        }

        setTimeout(() => {
            this.props.fetchAstroSavings(this.props.project.id, this.props.driver.driverId)
                .then((e) => {
                    const value = this.props.astroSavingsValue;
                    this.setState({savings: value + "%"});
                });
        },
        2500
        );
    }

    handleChangeReferenceSchedule(propertyName, value) {
        const v = value;
        this.handleChange(propertyName, v);

        this.setState({countryKey: "Custom"});
    }

    handleCountryDropdownChange(e) {
        this.handleChangeCountry(e.target.name);
    }

    handleChangeCountry(value) {
        this.setState({countryKey: value});

        if (value === "FR – Arrêté nuisances lumineuses") {
            this.props.handleChange(ASTRO_DIM_10.outputLevel1, "100");
            this.props.handleChange(ASTRO_DIM_10.outputLevel2, "70");
            this.props.handleChange(ASTRO_DIM_10.outputLevel3, "50");
            this.props.handleChange(ASTRO_DIM_10.outputLevel4, "50");
            this.props.handleChange(ASTRO_DIM_10.outputLevel5, "70");
            this.props.handleChange(ASTRO_DIM_10.time2, "16:30");
            this.props.handleChange(ASTRO_DIM_10.time3, "21:30");
            this.props.handleChange(ASTRO_DIM_10.time4, "07:00");
            this.props.handleChange(ASTRO_DIM_10.time5, "07:30");
        }
    }

    componentDidMount() {
        this.props.fetchDriverProperties(this.props.project.id, this.props.driver.driverId);
        const value = this.props.properties[ASTRO_DIM_10.energySavings]?.value || -1;
        this.setState({savings: value + "%"});
        this.handleChange(null, null);
    }

    setDefault(submode, shift) {
        this.props.handleChange(
            ASTRO_DIM_10.outputLevel1,
            this.props.properties[ASTRO_DIM_10.outputLevel1].valueMeta.default
        );
        this.props.handleChange(
            ASTRO_DIM_10.outputLevel2,
            this.props.properties[ASTRO_DIM_10.outputLevel2].valueMeta.default
        );
        this.props.handleChange(
            ASTRO_DIM_10.outputLevel3,
            this.props.properties[ASTRO_DIM_10.outputLevel3].valueMeta.default
        );
        this.props.handleChange(
            ASTRO_DIM_10.outputLevel4,
            this.props.properties[ASTRO_DIM_10.outputLevel4].valueMeta.default
        );
        this.props.handleChange(
            ASTRO_DIM_10.outputLevel5,
            this.props.properties[ASTRO_DIM_10.outputLevel5].valueMeta.default
        );
        this.props.handleChange(
            ASTRO_DIM_10.outputLevel6,
            this.props.properties[ASTRO_DIM_10.outputLevel6].valueMeta.default
        );
        this.props.handleChange(
            ASTRO_DIM_10.outputLevel7,
            this.props.properties[ASTRO_DIM_10.outputLevel7].valueMeta.default
        );
        this.props.handleChange(
            ASTRO_DIM_10.outputLevel8,
            this.props.properties[ASTRO_DIM_10.outputLevel8].valueMeta.default
        );
        this.props.handleChange(
            ASTRO_DIM_10.outputLevel9,
            this.props.properties[ASTRO_DIM_10.outputLevel9].valueMeta.default
        );
        this.props.handleChange(
            ASTRO_DIM_10.outputLevel10,
            this.props.properties[ASTRO_DIM_10.outputLevel10].valueMeta.default
        );

        const myDate = moment(submode === "0" ? "22:00" : submode === "1" ? "02:00" : "00:00", "HH:mm");

        if (shift) {
            myDate.add(shift, "minutes");
        }

        this.props.handleChange(ASTRO_DIM_10.time2, myDate.format("HH:mm"));
        this.props.handleChange(ASTRO_DIM_10.time3, myDate.add(1, "hours").format("HH:mm"));
        this.props.handleChange(ASTRO_DIM_10.time4, myDate.add(1, "hours").format("HH:mm"));
        this.props.handleChange(ASTRO_DIM_10.time5, myDate.add(1, "hours").format("HH:mm"));
        this.props.handleChange(ASTRO_DIM_10.time6, myDate.add(1, "hours").format("HH:mm"));
        this.props.handleChange(ASTRO_DIM_10.time7, myDate.add(1, "hours").format("HH:mm"));
        this.props.handleChange(ASTRO_DIM_10.time8, myDate.add(1, "hours").format("HH:mm"));
        this.props.handleChange(ASTRO_DIM_10.time9, myDate.add(1, "hours").format("HH:mm"));
        this.props.handleChange(ASTRO_DIM_10.time10, myDate.add(1, "hours").format("HH:mm"));
    }

    render() {
        const isAsttm = this.props.opmodesSelected && (this.props.opmodesSelected.name === "asttm" || this.props.opmodesSelected.name === "astroover");
        const displayLocation = !isAsttm && this.props.properties[ASTRO_DIM_10.submode].value === "0";
        const submode = this.props.properties[ASTRO_DIM_10.submode];
        const switchOnFadeTime = this.props.properties[ASTRO_DIM_10.switchOnFadeTime];
        const switchOffFadeTime = this.props.properties[ASTRO_DIM_10.switchOffFadeTime];
        const astroDimFadeTime = this.props.properties[ASTRO_DIM_10.astroDimFadeTime];

        const min =
            submode.value === "0"
                ? {x: new Date(1970, 0, 1, 12, 0, 0)}
                : submode.value === "1"
                    ? {x: new Date(1970, 0, 1, 0, 0, 0)}
                    : {x: new Date(1969, 11, 31, 22, 0, 0)};
        const max =
            submode.value === "0"
                ? {x: new Date(1970, 0, 2, 12, 0, 0), y: 100}
                : {x: new Date(1970, 0, 2, 0, 0, 0), y: 100};

        const tickFormat = {x: d3.timeFormat("%H")};

        const time = [];
        const tickValues = {x: time};
        if (submode.value === "0") {
            for (let i = 12; i < 24; i++) {
                time.push(new Date(1970, 0, 1, i, 0, 0));
            }
            for (let i = 0; i < 13; i++) {
                time.push(new Date(1970, 0, 2, i, 0, 0));
            }
        } else if (submode.value === "1") {
            for (let i = 0; i < 24; i++) {
                time.push(new Date(1970, 0, 1, i, 0, 0));
            }
            time.push(new Date(1970, 0, 2, 0, 0, 0));
        } else if (submode.value === "2") {
            for (let i = 1; i < 24; i++) {
                time.push(new Date(1970, 0, 1, i, 0, 0));
            }
            time.push(new Date(1970, 0, 2, 0, 0, 0));
        }

        const dataChart = this.getDataChart(this.props.properties, submode);

        return (
            <div>
                <Row>
                    <Col sm={12} md={4} lg={2} style={{marginBottom: "20px", minWidth: "200px"}}>
                        <Card className="card-feature-component" style={{width: "100%", height: "100%"}}>
                            <div className="card-header-feature">{<Trans i18nKey="Submode"/>}</div>
                            <Card.Body className="card-body-feature" style={{paddingTop: "0.75rem"}}>
                                <PropertyRadio
                                    property={submode}
                                    isChecked={submode.value === "0"}
                                    valueForTrue={"0"}
                                    title={<Trans i18nKey="Astro_Based"/>}
                                    handleChange={this.handleChange}
                                />
                                <PropertyRadio
                                    disabled={submode.valueMeta.max === "0"}
                                    property={submode}
                                    isChecked={submode.value === "1"}
                                    valueForTrue={"1"}
                                    title={<Trans i18nKey="Time_Based"/>}
                                    handleChange={this.handleChange}
                                />
                                <PropertyRadio
                                    disabled={!this.props.opmodesSelected?.name?.startsWith("astro_pd")}
                                    property={submode}
                                    isChecked={submode.value === "2"}
                                    valueForTrue={"2"}
                                    title={<Trans i18nKey="SD_triggered"/>}
                                    handleChange={this.handleChange}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={12} md={6} lg={5} style={{marginBottom: "20px"}}>
                        <Card
                            className={this.getClassName([astroDimFadeTime, switchOnFadeTime, switchOffFadeTime])}
                            style={{width: "100%", height: "100%"}}
                        >
                            <div className="card-header-feature">{<Trans i18nKey="Fade_Timing"/>}</div>
                            <Card.Body className="card-body-feature" style={{paddingTop: "0.75rem"}}>
                                <PropertyDropdown
                                    property={switchOnFadeTime}
                                    properties={switchOnFadeTime.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                    propertyDisplayFunc={getMinutes}
                                    title={<Trans i18nKey="Switch_On_Fade_Time"/>}
                                    measureUnit={"mm:ss"}
                                    min={switchOnFadeTime.valueMeta.min}
                                    max={switchOnFadeTime.valueMeta.max}
                                    handleChange={this.handleChange}
                                />
                                <PropertyDropdown
                                    property={astroDimFadeTime}
                                    properties={astroDimFadeTime.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                    propertyDisplayFunc={getMinutes}
                                    title={<Trans i18nKey="AstroDIM_Fade_Time"/>}
                                    measureUnit={"mm:ss"}
                                    min={astroDimFadeTime.valueMeta.min}
                                    max={astroDimFadeTime.valueMeta.max}
                                    handleChange={this.handleChange}
                                />

                                {submode.value === "0" ? (
                                    <PropertyDropdown
                                        property={switchOffFadeTime}
                                        properties={switchOffFadeTime.valueMeta.availableValues.sort(
                                            (a, b) => parseFloat(a) - parseFloat(b)
                                        )}
                                        propertyDisplayFunc={getMinutes}
                                        title={<Trans i18nKey="Switch_Off_Fade_Time"/>}
                                        measureUnit={"mm:ss"}
                                        min={switchOffFadeTime.valueMeta.min}
                                        max={switchOffFadeTime.valueMeta.max}
                                        handleChange={this.handleChange}
                                    />
                                ) : null}
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={12} md={6} lg={5} style={{marginBottom: "20px", minWidth: "500px"}}>
                        {displayLocation ? (
                            <Card
                                className={this.getClassName([astroDimFadeTime, switchOnFadeTime, switchOffFadeTime])}
                                style={{width: "100%", height: "100%"}}
                            >
                                <div className="card-header-feature">{<Trans i18nKey="Location"/>}</div>
                                <Card.Body className="card-body-feature" style={{paddingTop: "0.75rem"}}>
                                    <LocationComponent project={this.props.project}
                                        onUpdateProject={this.handleChange}/>
                                </Card.Body>
                            </Card>
                        ) : null}
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={12} lg={5} style={{marginBottom: "20px", minWidth: "700px"}}>
                        <Card className={super.getClassName(this.props.properties)}
                            style={{width: "100%", height: "100%"}}>
                            <div className="card-header-feature">{<Trans i18nKey="Reference_Schedule"/>}</div>
                            <Card.Body className="card-body-feature" style={{paddingTop: "0.75rem"}}>
                                <PropertyTableTimePicker10
                                    properties={this.props.properties}
                                    extraProperties={this.props.extraProperties}
                                    submodeProperty={ASTRO_DIM_10.submode}
                                    handleChange={this.handleChangeReferenceSchedule}
                                    sizeTitle={2}
                                    sizePickers={2}
                                    sizeMeasureUnit={2}
                                    firstRow={{
                                        title: <Trans i18nKey="Output_Level"/>,
                                        property: ASTRO_DIM_10.outputLevel,
                                        measureUnit: "%"
                                    }}
                                    secondRow={{
                                        title: <Trans i18nKey="Time"/>,
                                        property: ASTRO_DIM_10.time,
                                        measureUnit: "hh:mm"
                                    }}
                                    displayColors={true}
                                />
                                <div style={{paddingTop: "0.75rem", paddingLeft: "1.0rem"}}>
                                    <Trans
                                        i18nKey="Energy_Savings"/>: {submode.value === "2" || this.state.savings === "-1%" ? "N/A" : this.state.savings}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={12} md={12} lg={7} style={{marginBottom: "20px", minWidth: "1150px"}}>
                        <Card className="card-feature-component" style={{width: "100%", height: "100%"}}>
                            <div className="card-header-feature">{<Trans i18nKey="Graph"/>}</div>
                            <Card.Body className="card-body-feature" style={{paddingTop: "0.75rem"}}>
                                <DraggableAreaChart
                                    containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                    properties={this.props.properties}
                                    dataChart={dataChart}
                                    min={min}
                                    max={max}
                                    tickFormat={tickFormat}
                                    tickValues={tickValues}
                                    xThresholds={
                                        displayLocation
                                            ? [{
                                                value: new Date(1970, 0, 2, 0, this.props.midnightShift, 0),
                                                color: "rgb(0,0,255)"
                                            }]
                                            : null
                                    }
                                    xLabels={this.getXLabels(dataChart, submode)}
                                    x={{title: <Trans i18nKey="Time_h"/>}}
                                    y={{title: <Trans i18nKey="Output_Level_Percent"/>}}
                                    sections={{
                                        0: "area-dark",
                                        1: "area-light",
                                        2: "area-dark",
                                        3: "area-light",
                                        4: "area-dark",
                                        5: "area-light",
                                        6: "area-dark",
                                        7: "area-light",
                                        8: "area-dark",
                                        9: "area-light",
                                    }}
                                    handleChange={this.handleChartChange}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }

    getXLabels(dataChart, submode) {
        const labels = [];
        const smallLabels = [];
        const ticks = [];

        if (submode.value === "2") {
            ticks.push(new Date(1970, 0, 1, 0, 0, 0));
            labels.push({label: "SD", x: new Date(1970, 0, 1, 0, 0, 0)});
        }

        return {labels: labels, smallLabels: smallLabels, ticks: ticks};
    }

    getDataChart(properties, submode) {
        const dataChart = [];

        const minHourString = submode.value === "0" ? "13:00" : "00:00";
        const maxHourString = submode.value === "0" ? "11:00" : "24:00";

        const minHour = this.getNumberFromHour(minHourString, 0, submode);
        const maxHour = this.getNumberFromHour(maxHourString, 0, submode);

        const offsetSwitchOnFadeTime = getMinutesChart(properties[ASTRO_DIM_10.switchOnFadeTime].value);
        const offsetAstroDimFadeTime = getMinutesChart(properties[ASTRO_DIM_10.astroDimFadeTime].value);
        const offsetSwitchOffFadeTime =
            submode.value === "0" ? getMinutesChart(properties[ASTRO_DIM_10.switchOffFadeTime].value) : "0";

        let sectionCont = 0;

        if (submode.value !== "2") {
            dataChart.push({
                x: minHour,
                y: 0,
                section: sectionCont,
                color: "#32a852",
            });
        } else {
            dataChart.push({
                x: new Date(1969, 11, 31, 22, 0, 0),
                y: 0,
                section: sectionCont,
                color: "#a6a832",
            });

            dataChart.push({
                x: new Date(1969, 11, 31, 22, offsetSwitchOnFadeTime, 0),
                y: properties[ASTRO_DIM_10.outputLevel1].value || 0,
                section: sectionCont,
                color: "#a6a832",
            });
        }

        const refArray = [
            {x: minHourString, y: properties[ASTRO_DIM_10.outputLevel1].value},
            {
                x: submode.value !== "2" ? properties[ASTRO_DIM_10.time2].value : "00:00",
                y: properties[ASTRO_DIM_10.outputLevel2].value,
            },
            {x: properties[ASTRO_DIM_10.time3].value, y: properties[ASTRO_DIM_10.outputLevel3].value},
            {x: properties[ASTRO_DIM_10.time4].value, y: properties[ASTRO_DIM_10.outputLevel4].value},
            {x: properties[ASTRO_DIM_10.time5].value, y: properties[ASTRO_DIM_10.outputLevel5].value},
            {x: properties[ASTRO_DIM_10.time6].value, y: properties[ASTRO_DIM_10.outputLevel6].value},
            {x: properties[ASTRO_DIM_10.time7].value, y: properties[ASTRO_DIM_10.outputLevel7].value},
            {x: properties[ASTRO_DIM_10.time8].value, y: properties[ASTRO_DIM_10.outputLevel8].value},
            {x: properties[ASTRO_DIM_10.time9].value, y: properties[ASTRO_DIM_10.outputLevel9].value},
            {x: properties[ASTRO_DIM_10.time10].value, y: properties[ASTRO_DIM_10.outputLevel10].value},
            {x: maxHourString, y: properties[ASTRO_DIM_10.outputLevel10].value},
        ];

        let firstPoint = 0;
        let lastPoint = refArray.length - 1;
        for (let i = 1; i < refArray.length - 1; i++) {
            const ref = refArray[i];
            const refValue = this.getNumberFromHour(ref.x, 0, submode);

            if (minHour > refValue) {
                firstPoint = i;
            }
            if (maxHour < refValue) {
                lastPoint = i;
            }
        }

        for (let i = firstPoint; i <= lastPoint; i++) {
            const ref = refArray[i];

            if (i === firstPoint) {
                dataChart.push({
                    x: this.getNumberFromHour(minHourString, submode.value !== "2" ? offsetSwitchOnFadeTime : 0, submode),
                    y: +ref.y || 0,
                    section: sectionCont,
                });
            } else if (i === lastPoint) {
                const prevRef = refArray[i - 1];

                dataChart.push({
                    x: this.getNumberFromHour(maxHourString, -+offsetSwitchOffFadeTime, submode),
                    y: +prevRef.y || 0,
                    section: sectionCont,
                });
            } else {
                const prevRef = refArray[i - 1];

                dataChart.push({
                    x: this.getNumberFromHour(ref.x, 0, submode),
                    y: +prevRef.y || 0,
                    section: sectionCont,
                });

                sectionCont++;

                dataChart.push({
                    x: this.getNumberFromHour(ref.x, offsetAstroDimFadeTime, submode),
                    y: +ref.y || 0,
                    section: sectionCont,
                });
            }
        }

        dataChart.push({
            x: maxHour,
            y: 0,
        });

        return dataChart;
    }

    kelvinToHexTable(k) {
        const kTable = {
            1000: [255, 45, 0], //+
            1250: [255, 50, 5], //+
            1500: [255, 55, 10], //+
            1750: [255, 60, 15], //+
            2000: [255, 65, 20], //
            2250: [255, 90, 23], //+
            2500: [255, 115, 26], //+
            2750: [255, 140, 28], //+
            3000: [255, 166, 30], //
            3250: [255, 187, 48], //+
            3500: [255, 208, 66], //+
            3750: [255, 229, 84], //+
            4000: [255, 255, 103], //
            4250: [255, 255, 141], //+
            4500: [255, 255, 179], //+
            4750: [255, 255, 217], //+
            5000: [255, 255, 255], //
            5250: [239, 249, 255], //+
            5500: [226, 242, 255], //+
            5750: [213, 235, 255], //+
            6000: [200, 228, 255], //
            6250: [180, 216, 255], //+
            6500: [160, 206, 255], //+
            6750: [140, 196, 255], //+
            7000: [119, 186, 255], //
            7250: [107, 180, 255], //+
            7500: [97, 175, 255], //+
            7750: [87, 170, 255], //+
            8000: [77, 165, 255], //
            8250: [75, 160, 255],
            8500: [70, 155, 255],
            8750: [65, 150, 255],
            9000: [60, 145, 255],
            9250: [55, 140, 255],
            9500: [50, 135, 255],
            9750: [45, 130, 255],
            10000: [40, 125, 255],
        };

        // find the constant number
        const numbers = [];
        for (let i = 1000; i <= 10000; i += 250) {
            numbers.push(i);
        }

        let closestNumber = numbers[0];
        let smallestDifference = Math.abs(k - closestNumber);

        for (let i = 1; i < numbers.length; i++) {
            const currentNumber = numbers[i];
            const currentDifference = Math.abs(k - currentNumber);

            if (currentDifference < smallestDifference) {
                smallestDifference = currentDifference;
                closestNumber = currentNumber;
            }
        }
        return this.rgbToHex(kTable[closestNumber][0], kTable[closestNumber][1], kTable[closestNumber][2]);
    }

    rgbToHex(r, g, b) {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    }

    componentToHex(c) {
        var hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }

    getNumberFromHour(time, adding, submode, next) {
        if (submode.value === "0") {
            const momentDate = moment("1970/01/01 " + time, "YYYY/MM/DD HH:mm");

            momentDate.add(adding, "minutes");

            if (momentDate.hours() < 12 && momentDate.date() === 1) {
                momentDate.add(1, "days");
            }

            return momentDate.toDate();
        } else {
            const momentDate = moment("1970/01/01 " + time, "YYYY/MM/DD HH:mm");
            momentDate.add(adding, "minutes");

            return momentDate.toDate();
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        opmodesSelected: state.driver.opmodesSelected,
        projectLocation: state.project.location,
        issues: state.project.issueByProperty,
        midnightShift: state.project.midnightShift,
        astroSavingsValue: state.driver.astroSavingsValue,
    };
};

const mapDispatchToProps = {
    fetchDriverOpmodesSelected,
    fetchDriverProperties,
    fetchAstroSavings,
};

export default connect(mapStateToProps, mapDispatchToProps)(AstroDim10);
